import { observer } from "mobx-react";
import { useTranslation } from "@/i18n";
import { SecurityForm } from "@/components/profile-settings/security/security-form";
import { SettingsPageShell } from "@/components/shared/settings-page-shell";

export const ProfileSecurityPage = observer(function ProfileSecurityPage({
  onDirtyChange,
}: {
  onDirtyChange?: (dirty: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <SettingsPageShell
      title={t("profile_settings.security.title")}
      description={t("profile_settings.security.description")}
    >
      <SecurityForm onDirtyChange={onDirtyChange} />
    </SettingsPageShell>
  );
});
